import {Blockquote} from "@tiptap/extension-blockquote";
import {Bold} from "@tiptap/extension-bold";
import {BulletList} from "@tiptap/extension-bullet-list";
import {Code} from "@tiptap/extension-code";
import {CodeBlock} from "@tiptap/extension-code-block";
import {Color} from "@tiptap/extension-color";
import {HardBreak} from "@tiptap/extension-hard-break";
import {Heading} from "@tiptap/extension-heading";
import {Italic} from "@tiptap/extension-italic";
import {Link} from "@tiptap/extension-link";
import {ListItem} from "@tiptap/extension-list-item";
import {OrderedList} from "@tiptap/extension-ordered-list";
import {Paragraph} from "@tiptap/extension-paragraph";
import {Strike} from "@tiptap/extension-strike";
import {Text} from "@tiptap/extension-text";
import {TextAlign} from "@tiptap/extension-text-align";
import {TextStyle} from "@tiptap/extension-text-style";
import {Underline} from "@tiptap/extension-underline";
import ImageNode from "./image/ImageNode.js";
import InfoBoxNode from "./infoBox/InfoBoxNode.js";
import VideoEmbedNode from "./videoEmbed/VideoEmbedNode.js";

const createFeature = getExtensions => ({create: () => ({getExtensions})});

export default {
    paragraph: createFeature(() => [Paragraph]),
    text: createFeature(() => [Text]),
    hardBreak: createFeature(() => [HardBreak]),
    heading: createFeature(() => [Heading]),
    textStyle: createFeature(() => [TextStyle, Color]),
    codeBlock: createFeature(() => [CodeBlock]),
    bulletList: createFeature(() => [ListItem, BulletList]),
    orderedList: createFeature(() => [ListItem, OrderedList]),
    infoBox: createFeature(() => [InfoBoxNode]),
    blockQuote: createFeature(() => [Blockquote]),
    textAlign: createFeature(() => [TextAlign.configure({types: ["heading", "paragraph", "image", "videoEmbed"]})]),
    code: createFeature(() => [Code]),
    strikethrough: createFeature(() => [Strike]),
    bold: createFeature(() => [Bold]),
    underline: createFeature(() => [Underline]),
    italic: createFeature(() => [Italic]),
    link: createFeature(() => [Link.configure({openOnClick: false, HTMLAttributes: {class: "btn btn-link btn-primary d-inline", style: "vertical-align: unset"}})]),
    videoEmbed: createFeature(() => [VideoEmbedNode]),
    image: createFeature(() => [ImageNode])
};
